"use client";
import useStickyHeader from "@/hooks/useStickyHeader";
import { useModal } from "@/hooks/useModal";
// import { usePathname } from "next/navigation";

import Link from "next/link";
import Image from "next/image";
import Hyperlink from "@/components/ui/hyperlink";
import useToggle from "@/hooks/store/useToggle";
import MobileMenu from "../layout/headers/mobile-menu";
import Nav from "../layout/headers/nav";
import FormModal from "./form-modal";

const Header = () => {
    const isSticky = useStickyHeader();
    const isMenuOpen = useToggle((state) => state.isMenuOpen);
    const toggleMenu = useToggle((state) => state.toggleMenu);

    const modal = useModal();
    // const pathname = usePathname();
    // const is1bfsPage = pathname?.includes("1bfs");

    return (
        <>
            <header
                className={`desilo-header main-header ${isSticky ? "sticky-menu dark-header" : "header-bg-blur"
                    }`}
            >
                {/* {!is1bfsPage && (
                    <div className="desilo-header__banner">
                        <Link href="/1bfs">
                            We’re attending 1 Billion Followers Summit in Dubai, meet us there
                            <span>
                                <i className="ms-2 fa-solid fa-arrow-right"></i>
                            </span>
                        </Link>
                    </div>
                )} */}
                <div className="sticky-wrap">
                    <div className="sticky-active">
                        <div className="container custom-container">
                            <div className="row gx-3 align-items-center justify-content-between">
                                <div className="col-8 col-sm-auto">
                                    <div className="header-logo">
                                        <Link href="/">
                                            <Image
                                                height={25}
                                                width={150}
                                                src={`${isSticky ? "/images/logo-2.svg" : "/images/logo-dark.svg"}`}
                                                alt="logo"
                                                priority
                                            />
                                        </Link>
                                    </div>
                                </div>
                                <div className="col text-end text-lg-end">
                                    {/* navigation start */}
                                    <Nav />
                                    {/* navigation end */}
                                    <button
                                        className="menuBar-toggle desilo-menu-toggle d-inline-block d-lg-none"
                                        onClick={toggleMenu}
                                    >
                                        <svg
                                            xmlns="http://www.w3.org/2000/svg"
                                            width={40}
                                            height={40}
                                            viewBox="0 0 40 40"
                                            fill="none"
                                        >
                                            <path
                                                d="M24.4444 26V28H0V26H24.4444ZM40 19V21H0V19H40ZM40 12V14H15.5556V12H40Z"
                                                fill={`${isSticky ? "white" : "#0f0f0f"}`}
                                            />
                                        </svg>
                                    </button>
                                </div>
                                <div className="col-auto d-none d-lg-block ms-4">
                                    <Hyperlink
                                        className="small-btn"
                                        href="/contact"
                                        variant={isSticky ? "tertiary" : "primary"}
                                    >
                                        Get in touch
                                    </Hyperlink>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </header>
            <MobileMenu onClose={toggleMenu} isOpen={isMenuOpen} />

            {/* Form Modal */}
            <FormModal
                isOpen={modal.isOpen}
                onClose={modal.closeModal}
                onSubmit={() => {
                    modal.closeModal();
                }}
                title="Fill the form here"
                submitButtonText="Download"
                dialogSlug="Header Contact"
            />
        </>
    );
};

export default Header;
